import React from 'react';
import { Modal } from '@testsigma/atoms';

import {
  UserConnectionModalScreens,
  useSFConnectionState,
} from '@contexts/sf-connection-context';

import {
  UserConnectionCreateForm,
  UserConnectionEditForm,
  UserConnectionDetailsForm,
  UserConnectionSuccessfulScreen,
  UserConnectionFailedScreen,
} from '../components/connection-modal-screens';
import { TestConnectionSuccessModal } from '@modules/salesforce/metadata-connections/components/connection-modal-screens/test-connection-success-modal';

export const UserConnectionModal: React.FC = () => {
  const { overlayMode, userConnectionModalScreen } = useSFConnectionState();

  if (overlayMode !== 'user_connection') {
    return null;
  }

  return (
    <Modal
      showCloseButton={false}
      closeOnEscape={false}
      closeOnOutsideClick={false}
      isOpen={overlayMode === 'user_connection'}
      className='!rounded-lg !w-[580px] !p-0'
      // onClose={() => onClose(connection)}
    >
      {userConnectionModalScreen ===
        UserConnectionModalScreens.CONNECTION_CREATE_SCREEN && (
        <UserConnectionCreateForm />
      )}

      {userConnectionModalScreen ===
        UserConnectionModalScreens.CONNECTION_EDIT_SCREEN && (
        <UserConnectionEditForm />
      )}

      {userConnectionModalScreen ===
        UserConnectionModalScreens.CONNECTION_DETAILS_SCREEN && (
        <UserConnectionDetailsForm />
      )}

      {userConnectionModalScreen ===
        UserConnectionModalScreens.CONNECTION_AUTH_FAILURE_SCREEN && (
        <UserConnectionFailedScreen />
      )}

      {(userConnectionModalScreen ===
        UserConnectionModalScreens.CONNECTION_SUCCESSFUL_SCREEN ||
        userConnectionModalScreen ===
          UserConnectionModalScreens.CONNECTION_UPDATE_SUCCESS_SCREEN) && (
        <UserConnectionSuccessfulScreen />
      )}
      {userConnectionModalScreen === UserConnectionModalScreens.CONNECTION_TEST_SUCCESSFUL  && (
        <TestConnectionSuccessModal isUserConnection/>
      )}

    </Modal>
  );
};
